// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import {
  cleanTooltipInfo,
  clearEngineLightDtc,
  loadActiveLampDtc,
  loadActiveLampDtcSuccess,
  loadDtcList,
  loadDtcListSuccess,
  loadMilStatus,
  loadMilStatusSuccess,
  loadTooltipDtc,
  loadTooltipDtcSuccess,
  loadTooltipMilStatus,
  loadTooltipMilStatusSuccess,
  vehicleDiagnosticsFailure,
} from '../actions';
import { ShortDtc } from '../../models/dtc';

export const getVehicleDiagnosticsFeatureKey = 'vehicleDiagnostics';

export interface State {
  dtc: ShortDtc[];
  mil: number;
  activeLampDtc: ShortDtc[];
  loading: boolean;
  loadingMil: boolean;
  activeLampLoading: boolean;
  tooltipMil: number;
  tooltipDtc: ShortDtc[];
  tooltipLoading: boolean;
  error: any;
}

export const initialState: State = {
  dtc: [],
  mil: null,
  activeLampDtc: [],
  loading: false,
  loadingMil: false,
  activeLampLoading: false,
  tooltipMil: null,
  tooltipDtc: null,
  tooltipLoading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    loadDtcList,
    (state): State => ({
      ...state,
      loading: true,
      dtc: [],
    }),
  ),
  on(loadDtcListSuccess, (state, action) => ({
    ...state,
    loading: false,
    dtc: action.shortDtc,
  })),
  on(
    loadActiveLampDtc,
    (state): State => ({
      ...state,
      loading: true,
      activeLampDtc: [],
    }),
  ),
  on(loadActiveLampDtcSuccess, (state, action) => ({
    ...state,
    loading: false,
    activeLampDtc: action.activeLampDtc,
  })),
  on(loadTooltipDtc, (state) => ({
    ...state,
    tooltipLoading: true,
  })),
  on(loadTooltipDtcSuccess, (state, action) => ({
    ...state,
    tooltipDtc: action.tooltipDtc,
    tooltipLoading: false,
  })),
  on(loadMilStatus, (state) => ({
    ...state,
    loadingMil: true,
  })),
  on(loadMilStatusSuccess, (state, action) => ({
    ...state,
    mil: action.milStatus,
    loadingMil: false,
  })),
  on(loadTooltipMilStatus, (state) => ({
    ...state,
    tooltipLoading: true,
  })),
  on(loadTooltipMilStatusSuccess, (state, action) => ({
    ...state,
    tooltipMil: action.tooltipMilStatus,
    tooltipLoading: false,
  })),
  on(
    cleanTooltipInfo,
    (state): State => ({
      ...state,
      tooltipDtc: null,
    }),
  ),
  on(
    clearEngineLightDtc,
    (state): State => ({
      ...state,
      dtc: [],
      mil: null,
    }),
  ),
  on(vehicleDiagnosticsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const getDtcListState = (state: State) => state.dtc;
export const getDtcListLoading = (state: State) => state.loading;
export const getMilStatus = (state: State) => state.mil;
export const getTooltipDtc = (state: State) => state.tooltipDtc;
export const getTooltipLoading = (state: State) => state.tooltipLoading;
export const getTooltipMilStatus = (state: State) => state.tooltipMil;
export const getActiveLampDtc = (state: State) => state.activeLampDtc;
export const getMilLoading = (state: State) => state.loadingMil;
export const getActiveLampLoading = (state: State) => state.activeLampLoading;
